export default {
  xxlarge: 'min-width: 1800px',
  xlarge: 'min-width: 1200px',
  large: 'min-width: 800px',
  medium: 'max-width: 800px',
  small: 'max-width: 600px',
  xsmall: 'max-width: 400px',
};
